import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../../context/auth';
import { useRoles } from '../../../hooks/useRoles';
import MobileMenu from './MobileMenu';
import './Header.css';

const Header = () => {
  const { currentUser, logout } = useAuth();
  const { canAccessAdminPanel } = useRoles();
  const location = useLocation();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  // Show minimal header on auth pages
  if (location.pathname === '/login' || location.pathname === '/signup' || location.pathname === '/forgot-password') {
      return (
    <nav className="navbar auth-navbar">
      <div className="nav-container">
        <div className="nav-logo">
          <Link to="/">
            <img src="/logo.png" alt="Literally Possible Logo" className="nav-logo-img" />
          </Link>
        </div>
        <div className="nav-menu">
          <Link to="/" className="nav-back-link">← Back to Home</Link>
        </div>
        <MobileMenu />
      </div>
    </nav>
  );
  }

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-logo">
          <Link to="/">
            <img src="/logo.png" alt="Literally Possible Logo" className="nav-logo-img" />
          </Link>
        </div>
        <div className="nav-menu">
          <a href="#services">Services</a>
          <a href="#about">About</a>
          <a href="#contact">Contact</a>
          {currentUser ? (
            <>
              <Link to="/dashboard" className="nav-auth-link">Dashboard</Link>
              {canAccessAdminPanel && (
                <Link to="/admin" className="nav-auth-link admin-link">Admin</Link>
              )}
              <button onClick={handleLogout} className="nav-auth-button">Sign Out</button>
            </>
          ) : (
            <>
              <Link to="/login" className="nav-auth-link">Sign In</Link>
              <Link to="/signup" className="nav-auth-button">Sign Up</Link>
            </>
          )}
        </div>
        <MobileMenu />
      </div>
    </nav>
  );
};

export default Header; 